import { helpers } from 'vuelidate/lib/validators';
import moment from 'moment';
export var alphaNumLower = helpers.regex('alphaNumLower', /^[a-z0-9]+$/);
export var isValidEmail = function isValidEmail(v) {
  var emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
  return emailPattern.test(v);
};
export var isValidForMask = function isValidForMask(v, mask) {
  // only check validity if value present, do not assume value required
  if (!v) {
    return true;
  } // check mask and value are both the same length


  return v.length === mask.length;
};
export var isBeforeDate = function isBeforeDate(val) {
  var setCheckDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var checkDate = moment(setCheckDate, 'DD/MM/YYYY', true);
  var testDate = moment(val, 'DD/MM/YYYY', true);
  return checkDate.diff(testDate, 'days') > 0;
};
export var isValidPastDate = function isValidPastDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var boundary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  var checkDate = moment(boundary, format, true);
  var testDate = moment(date, format, true);
  return moment(testDate).isBefore(checkDate);
};
export var isValidDate = function isValidDate(val, format) {
  var date = moment(val, format, true); // 29/02 is not a valid date unless a year is supplied so this is a bypass for when there isn't a year field.

  return val === '29/02' || date.isValid();
};
export var alphaNumDashes = helpers.regex('alphaNumDashes', /^[a-zA-Z0-9_-]+$/);
export var anniversary = function anniversary(val) {
  return !helpers.req(val) || moment(val + '/1904', 'DD/MM/YYYY', true).isValid();
};
export var dateOfBirth = function dateOfBirth(val) {
  return !helpers.req(val) || moment(val, 'DD/MM/YYYY', true).isValid();
};